import { ScrollReveal } from '@/components/effects/ScrollReveal';
import { MessageSquare, Search, Zap, CheckCircle } from 'lucide-react';

const steps = [
  { icon: MessageSquare, number: '01', title: 'Discovery', desc: 'We listen. Understand your goals, audit current state, and identify opportunities.' },
  { icon: Search, number: '02', title: 'Assessment', desc: 'Deep-dive analysis. Technical audit, threat modelling, or skills gap analysis.' },
  { icon: Zap, number: '03', title: 'Execution', desc: 'Hands-on delivery. Implementation, training, or campaign launch by our specialists.' },
  { icon: CheckCircle, number: '04', title: 'Review', desc: 'Measure results. Detailed reporting, next steps, and continuous improvement.' },
];

export const ProcessSection = () => {
  return (
    <section
      data-testid="process-section"
      className="py-14 sm:py-20"
      style={{ background: 'var(--bg)' }}
    >
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-12">
            <p className="font-body text-xs uppercase tracking-[0.22em] mb-3" style={{ color: 'var(--a)' }}>
              How We Work
            </p>
            <h2
              className="font-display font-extrabold tracking-[-0.03em] mb-4"
              style={{ fontSize: 'clamp(2rem, 4.5vw, 3.8rem)', color: 'var(--white)' }}
            >
              Four steps. Clear outcomes.
            </h2>
          </div>
        </ScrollReveal>

        <div className="relative">
          {/* Connecting Line */}
          <div
            className="hidden lg:block absolute top-1/2 left-0 right-0 h-[1px] -translate-y-1/2"
            style={{ background: 'var(--b1)' }}
          />

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((step, i) => {
              const Icon = step.icon;
              return (
                <ScrollReveal key={step.number} delay={i * 0.08}>
                  <div
                    data-testid={`process-step-${i}`}
                    className="relative text-center group"
                  >
                    {/* Circle */}
                    <div
                      className="w-16 h-16 mx-auto mb-5 rounded-full flex items-center justify-center transition-all duration-300 relative z-10"
                      style={{
                        background: 'var(--l2)',
                        border: '1px solid var(--b1)',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = 'var(--a)';
                        e.currentTarget.style.boxShadow = '0 0 30px rgba(139,92,246,0.15)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = 'var(--b1)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      <span className="font-mono text-sm font-bold" style={{ color: 'var(--a)' }}>{step.number}</span>
                    </div>
                    <h3 className="font-display text-base font-bold mb-2" style={{ color: 'var(--white)' }}>{step.title}</h3>
                    <p className="font-body text-sm font-light" style={{ color: 'var(--tm)', lineHeight: '1.65' }}>{step.desc}</p>
                  </div>
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
